import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Deleted Status Cell Renderer Component
 *
 * Muestra un badge "Eliminado" cuando una posición fue eliminada.
 * Se usa en la columna "Estado" del Order Customer Log.
 *
 * Uso en ColDef:
 * ```typescript
 * {
 *   field: "_deleted",
 *   headerName: "Estado",
 *   cellRenderer: DeletedStatusCellRendererComponent,
 * }
 * ```
 */
@Component({
  selector: 'app-deleted-status-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="text-sm">{{ isDeleted ? 'Sí' : 'No' }}</span>`,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      height: 100%;
    }
  `]
})
export class DeletedStatusCellRendererComponent<T> implements CellRenderer<T, boolean> {
  /**
   * Parameters from the grid containing the cell value and row data
   */
  @Input() params!: CellRendererParams<T, boolean>;

  get isDeleted(): boolean {
    return this.params?.value === true;
  }
}
